import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import type { DrawerArgs } from '../drawer';
import useFrontileClass from '@frontile/core/helpers/use-frontile-class';
export interface DrawerBodyArgs extends Pick<DrawerArgs, 'placement'> {
    size: string;
}
export interface DrawerBodySignature {
    Args: DrawerBodyArgs;
    Element: HTMLDivElement;
    Blocks: {
        default: [];
    };
}
export default class DrawerBody extends Component<DrawerBodySignature> {
    static{
        template(`
    <div
      class={{useFrontileClass "drawer" @placement @size part="body"}}
      ...attributes
    >
      {{yield}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
